import type RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import type ProtectionViewState from 'owa-mail-protection-types/lib/schema/ProtectionViewState';
import type { MailboxInfo } from 'owa-client-types';
import {
    ENCRYPT_DNF_GUID,
    ENCRYPT_GUID,
    ENCRYPT_DNRA_GUID,
} from 'owa-protection-store/lib/store/schema/rms/EncryptionGUID';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

// For both New Compose Scenario and Reply/Forward Scenario
export default function getComplianceId(
    protectionViewState?: ProtectionViewState,
    mailboxInfo?: MailboxInfo
): string | undefined {
    let complianceId: string | undefined;
    const selectedCLPLabel = protectionViewState?.clpViewState?.selectedCLPLabel;
    const originalCLPLabel = protectionViewState?.clpViewState?.originalCLPLabel;
    const IRMChanged = protectionViewState?.IRMChanged;
    const shouldProcessCompliance =
        mailboxInfo &&
        isAccountFeatureEnabled('snc-clp-encrypt-sentItems', mailboxInfo) &&
        (selectedCLPLabel?.id !== originalCLPLabel?.id || IRMChanged);

    if (shouldProcessCompliance) {
        const IRMData: RightsManagementLicenseDataType | undefined = protectionViewState?.IRMData;
        const labelTemplateId = selectedCLPLabel?.rmsTemplateId;
        const hasDNFRights =
            selectedCLPLabel?.rightsProtectMessageDNF ||
            IRMData?.RmsTemplateId === ENCRYPT_DNF_GUID;
        const hasEORights =
            selectedCLPLabel?.rightsProtectMessageEncryptOnly ||
            IRMData?.RmsTemplateId === ENCRYPT_GUID;

        if (labelTemplateId) {
            complianceId = labelTemplateId;
        } else if (hasDNFRights) {
            complianceId = ENCRYPT_DNF_GUID;
        } else if (hasEORights) {
            complianceId = ENCRYPT_GUID;
        } else if (IRMData?.RmsTemplateId === ENCRYPT_DNRA_GUID) {
            complianceId = ENCRYPT_DNRA_GUID;
        } else {
            complianceId = '0';
        }
    }

    return complianceId;
}
